module.exports = __webpack_public_path__ + "img/welcome_labo.e450ae09.jpg";